import type { SVGProps } from "react";
export default function SvgWord(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 24 23"
			{...props}
		>
			<g clipPath="url(#clip0_496_844)">
				<path fill="white" d="M23.662 2.842H10.01v17.51h13.653z" />
				<path
					fill="#2A5699"
					d="M9.199 2.247a.973.973 0 0 0-.97.98V19.77c0 .542.433.98.97.98H23.03a.973.973 0 0 0 .969-.98V3.228a.973.973 0 0 0-.969-.98zm-.195.813h14.213v16.867H9.004z"
				/>
				<path fill="#2A5699" d="M21.559 4.795h-9.957v1.048h9.957z" />
				<path fill="#2A5699" d="M21.559 9.74h-9.957v1.048h9.957z" />
				<path fill="#2A5699" d="M21.559 7.267h-9.957v1.049h9.957z" />
				<path fill="#2A5699" d="M21.559 12.212h-9.957v1.049h9.957z" />
				<path fill="#2A5699" d="M21.559 14.759h-9.957v1.049h9.957z" />
				<path fill="#2A5699" d="M21.559 17.231h-9.957v1.05h9.957z" />
				<path fill="#2C5A9E" d="M13.654 23V0L0 2.3v18.4z" />
				<path
					fill="white"
					d="m2.362 8.05 1.328 6.86q.713.064 1.428.085l.973-4.51c.04-.143.058-.3.075-.6.018.303.03.411.074.6l.962 4.636 1.555.094 1.727-7.655-1.523.092-.876 5.08a3 3 0 0 0-.074.599 1.8 1.8 0 0 0-.074-.599l-.973-4.96-1.374.083-1.048 4.877a3 3 0 0 0-.074.45 5 5 0 0 0-.073-.6L3.686 7.97z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_496_844">
					<rect width={24} height={23} fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
